import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { use, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Profile from "../components/Profile";
import PenPalProfile from "../components/PenPalProfile";
import axios from "axios";
import { Dialog, DialogActions, DialogContent, Button } from "@mui/material";
import { web_url } from "../../constant";


function StudentsDashboardPageDesktop() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };
    const [loadingPage, setLoadingPage] = useState(false);
    const [studentName, setStudentName] = useState('')

    useEffect(() => {
        if (sessionStorage.getItem('greetings')) {
            const greetings = sessionStorage.getItem("greetings");
            if (greetings === 'true') {
                setLoadingPage(true);
                const getLogDetails = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails = getLogDetails();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails.token}`,
                    },
                };
                const apiUrl = `${web_url}/api/auth/students/${logDetails.email}`
                axios.get(apiUrl, configToken)
                    .then((response) => {
                        localStorage.setItem('email', response.data.userEmail);
                        localStorage.setItem('school', response.data.school);
                        localStorage.setItem('teacherName', response.data.teacherName);
                        localStorage.setItem('assignedClass', response.data.assignedClass);
                        localStorage.setItem('penpalEmail', response.data.penpalEmail || "empty");
                        localStorage.setItem('preferredLang', response.data.preferredLanguage);
                        setLanguage(response.data.preferredLanguage);
                        setStudentName(response.data.userFullName);

                        const teacherD = {
                            school: response.data.school,
                            assignedClass: response.data.assignedClass,
                            district: response.data.district
                        }

                        const config = {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${logDetails.token}`,
                            },
                        };

                        axios.post(`${web_url}/api/auth/teachers/filter`, teacherD, config).then((responseNew) => {

                            const teacherEmail = (responseNew.data)[0].userEmail;
                            localStorage.setItem('teacherEmail', teacherEmail)

                            const getLogDetails2 = () => {
                                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                            };
                            const logDetails2 = getLogDetails2();

                            const configToken = {
                                headers: {
                                    'Authorization': `Bearer ${logDetails2.token}`,
                                },
                            };

                            axios.get(`${web_url}/api/email-threads/participants/${logDetails.email}`, configToken).then((response) => {
                                let allMessages = response.data.flatMap(thread =>
                                    thread.messages.map(message => ({
                                        ...message,
                                        threadId: thread.threadId,
                                        subject: thread.subject || " ",
                                        initialSender: thread.messages[0].sender,
                                        translatedSubject: thread.translatedSubject || " ",
                                        sentAt: formatDate(message.sentAt),
                                        sentAtOriginal: formatDateNew(message.sentAt),
                                        other: thread.participants.find(email => email !== message.sender) || null,
                                        isRead: thread.participantsStatus
                                            ? thread.participantsStatus.find(person => person.email === logDetails.email)?.isRead ?? true
                                            : true
                                    }))
                                );
                                console.log("All messages:", allMessages);

                                const today = new Date();
                                const currentDay = today.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6

                                // Calculate Monday (start of the week)
                                const diffToMonday = currentDay === 0 ? -6 : 1 - currentDay;
                                const weekStart = new Date(today);
                                weekStart.setDate(today.getDate() + diffToMonday);
                                weekStart.setHours(0, 0, 0, 0);

                                // Calculate Sunday (end of the week)
                                const weekEnd = new Date(weekStart);
                                weekEnd.setDate(weekStart.getDate() + 6);
                                weekEnd.setHours(23, 59, 59, 999);

                                // Filter messages from this week (sent or received)
                                const sentMessagesPerWeek = allMessages.filter(msg => {
                                    const sentDate = new Date(msg.sentAtOriginal); // always use ISO format
                                    return (
                                        msg.type === "PENPAL" &&
                                        msg.isDraft === "FALSE" &&
                                        (msg.sender === logDetails.email) &&
                                        sentDate >= weekStart &&
                                        sentDate <= weekEnd
                                    );
                                });
                                // console.log("Sent messages per week:", sentMessagesPerWeek);
                                localStorage.setItem('sentMessagesPerWeek', sentMessagesPerWeek.length.toString());
                                console.log("Sent messages per week:", sentMessagesPerWeek.length);


                                setLoadingPage(false);
                                setOpen(true);

                            }).catch((err) => {
                                setLoadingPage(false);
                                setOpen(true);
                            })
                        }).catch((errTeach) => {
                            setLoadingPage(false);
                            setOpen(true);
                            console.log("Error fetching teacher details:");

                        })
                    })
                    .catch((err) => {
                        setLoadingPage(false);
                        setOpen(true);
                        console.log("error occured");
                    });
                sessionStorage.removeItem('greetings');
            }
        } else {
            const getLogDetails = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails = getLogDetails();
            if (logDetails) {
                setLoadingPage(true);
                const getLogDetails2 = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails2 = getLogDetails2();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails2.token}`,
                    },
                };
                const apiUrl = `${web_url}/api/auth/students/${logDetails.email}`
                axios.get(apiUrl, configToken)
                    .then((response) => {

                        localStorage.setItem('email', response.data.userEmail);
                        localStorage.setItem('school', response.data.school);
                        localStorage.setItem('teacherName', response.data.teacherName);
                        localStorage.setItem('assignedClass', response.data.assignedClass);
                        localStorage.setItem('penpalEmail', response.data.penpalEmail || "empty");
                        localStorage.setItem('preferredLang', response.data.preferredLanguage);
                        // setLanguage(response.data.preferredLanguage);
                        setStudentName(response.data.userFullName);
                        const teacherD2 = {
                            school: response.data.school,
                            assignedClass: response.data.assignedClass,
                            district: response.data.district
                        }

                        const config2 = {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${logDetails.token}`,
                            },
                        };

                        axios.post(`${web_url}/api/auth/teachers/filter`, teacherD2, config2).then((responseNew) => {

                            const teacherEmail2 = (responseNew.data)[0].userEmail;
                            localStorage.setItem('teacherEmail', teacherEmail2)
                            const getLogDetails2 = () => {
                                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                            };
                            const logDetails2 = getLogDetails2();

                            const configToken = {
                                headers: {
                                    'Authorization': `Bearer ${logDetails2.token}`,
                                },
                            };
                            axios.get(`${web_url}/api/email-threads/participants/${logDetails.email}`, configToken).then((response) => {
                                let allMessages = response.data.flatMap(thread =>
                                    thread.messages.map(message => ({
                                        ...message,
                                        threadId: thread.threadId,
                                        subject: thread.subject || " ",
                                        initialSender: thread.messages[0].sender,
                                        translatedSubject: thread.translatedSubject || " ",
                                        sentAt: formatDate(message.sentAt),
                                        sentAtOriginal: formatDateNew(message.sentAt),
                                        other: thread.participants.find(email => email !== message.sender) || null,
                                        isRead: thread.participantsStatus
                                            ? thread.participantsStatus.find(person => person.email === logDetails.email)?.isRead ?? true
                                            : true
                                    }))
                                );
                                console.log("All messages:", allMessages);

                                const today = new Date();
                                const currentDay = today.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6

                                // Calculate Monday (start of the week)
                                const diffToMonday = currentDay === 0 ? -6 : 1 - currentDay;
                                const weekStart = new Date(today);
                                weekStart.setDate(today.getDate() + diffToMonday);
                                weekStart.setHours(0, 0, 0, 0);

                                // Calculate Sunday (end of the week)
                                const weekEnd = new Date(weekStart);
                                weekEnd.setDate(weekStart.getDate() + 6);
                                weekEnd.setHours(23, 59, 59, 999);

                                // Filter messages from this week (sent or received)
                                const sentMessagesPerWeek = allMessages.filter(msg => {
                                    const sentDate = new Date(msg.sentAtOriginal); // always use ISO format
                                    return (
                                        msg.type === "PENPAL" &&
                                        msg.isDraft === "FALSE" &&
                                        (msg.sender === logDetails.email) &&
                                        sentDate >= weekStart &&
                                        sentDate <= weekEnd
                                    );
                                });
                                // console.log("Sent messages per week:", sentMessagesPerWeek);
                                console.log("Sent messages per week:", sentMessagesPerWeek);
                                localStorage.setItem('sentMessagesPerWeek', sentMessagesPerWeek.length.toString());

                                setLoadingPage(false);


                            }).catch((err) => {
                                setLoadingPage(false);

                            })
                        }).catch((errTeach) => {
                            setLoadingPage(false);
                            console.log("Error fetching teacher details");
                        })
                    })
                    .catch((err) => {
                        console.log("error occured");
                    });
            }

        }
    }, [])

    const formatDateNew = (timestamp) => {
        return new Date(timestamp).toISOString(); // Ensures cross-browser compatibility
    };

    const formatDate = (timestamp) => {
        const dateObj = new Date(timestamp);

        // Convert to IST (UTC + 5:30)
        // const istOffset = 0;
        const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
        const istTime = new Date(dateObj.getTime() + istOffset);

        // Use .getFullYear(), .getMonth(), etc., instead of .getUTC*
        const year = istTime.getFullYear();
        const month = String(istTime.getMonth() + 1).padStart(2, "0"); // Ensure 2 digits
        const day = String(istTime.getDate()).padStart(2, "0"); // Ensure 2 digits
        const hours = String(istTime.getHours()).padStart(2, "0"); // Corrected
        const minutes = String(istTime.getMinutes()).padStart(2, "0"); // Corrected
        const sec = String(istTime.getSeconds()).padStart(2, "0"); // Corrected

        // console.log("old", timestamp);
        // console.log("new", `${year}-${month}-${day} ${hours}:${minutes}:${sec}`);

        return `${year}-${month}-${day} ${hours}:${minutes}:${sec}`;
    }


    useEffect(() => {
        if (loadingPage) {
            setOpen2(true);
        } else {
            setOpen2(false);
        }
    }, [loadingPage])

    const [open2, setOpen2] = useState(false);
    const [languageLoading, setLanguageLoading] = useState(false)

    const changeLanguageButtonClick = (lang, langAbbr) => {
        setLoadingPage(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const languageChange = {
            preferredLanguage: lang
        }
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };
        axios.patch(`${web_url}/api/auth/students/${logDetails.email}`, languageChange, config).then((res) => {
            setLanguage(lang);
            setLoadingPage(false);
            changeLanguage(langAbbr);
        }).catch((err) => {
            alert('Error occured. Cannot change language now.')
            setLoadingPage(false);
        })
    }

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 1270) {
                navigate('/mobile/student/dashboard')
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const checkAuth = () => {
            const logDetails = getLogDetails();
            const currentTime = new Date();

            if (!logDetails) {
                alert("Please re-sign up to continue");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            } else if (logDetails.category.toLowerCase() !== "student") {
                alert("Please re-sign up to continue");
                // localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            }

            if (sessionStorage.getItem('exp')) {
                if (new Date(sessionStorage.getItem('exp')) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
                    alert("Please re-sign up to continue");
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            } else {
                sessionStorage.setItem('exp', logDetails.exp);
                if (new Date(logDetails.exp) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            }
        };

        checkAuth(); // Run on mount

        const handleStorageChange = (event) => {
            if (event.key === "logDetails") {
                checkAuth(); // Re-check authentication if storage changes
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-no-repeat bg-cover min-h-screen w-screen xl:pt-[50px]`}>
            <div className="xl:hidden absolute top-0 left-0 py-[25px] pl-[20px] md:pl-[30px] lg:pl-[40px]">
                <div className="flex justify-center items-center" >
                    <img className="h-[50px] md:h-[70px] lg:h-[90px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px]  font-semibold text-[16px] md:text-[20px] lg:text-[25px]">{t('t1')}</p>
                </div>
            </div>
            <Menu as="div" className="xl:hidden absolute top-0 right-0 text-left items-right py-[30px] md:py-[35px] pr-[20px] md:pr-[30px] lg:pr-[40px]">
                <div>
                    <MenuButton disabled className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                    </MenuButton>
                </div>
            </Menu>
            <div className="rounded-md hidden xl:grid grid-cols-3 py-[5px] 2xl:py-[10px] bg-gradient-to-r from-[#FFA803] to-[#FFD12E] mx-[70px] px-[20px]">
                <div className="flex justify-start items-center">
                    <img className="h-[40px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px] font-semibold text-[20px]">{t('t1')}</p>
                </div>
                <div className="grid grid-cols-3 w-full">
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/home-w.svg" onClick={() => navigate('/desktop/student/dashboard')} alt="home" />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t410')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/mail-b.svg"
                            onClick={() => {
                                const mailRequest = {
                                    type: 'new',
                                    subject: 'nothing'
                                };
                                localStorage.setItem('threadId', JSON.stringify(mailRequest));
                                navigate('/desktop/student/mailbox')
                            }} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t411')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/settings-b.svg" onClick={() => navigate('/desktop/student/settings')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t153')}
                        </span>
                    </div>
                </div>
                <div className="flex justify-end items-center">
                    <Menu as="div" className="text-left items-right">
                        <div>
                            <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                                {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                                <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            <div className="py-1">
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("English");
                                            changeLanguage('en');
                                        }}
                                    >
                                        English
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Sinhala");
                                            changeLanguage('si');
                                        }}
                                    >
                                        සිංහල
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Tamil");
                                            changeLanguage('ta');
                                        }}
                                    >
                                        தமிழ்
                                    </button>
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </Menu>
                </div>
            </div>
            <div className=" hidden xl:grid grid-cols-2 w-full">
                <div>
                    <Profile t={t} lang={i18n.language} />
                </div>
                <div className=" ">
                    <PenPalProfile t={t} lang={i18n.language} />
                </div>
            </div>
            <div className="xl:hidden grid grid-cols-5 fixed bottom-0 w-full border-t border-gray-300 bg-white">
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/home.svg" alt="home" /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/mail.svg" /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/person.svg" /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/message.svg" /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/settings.svg" /></div>
            </div>

            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className="flex flex-col justify-center items-center">
                            <p className="font-bold text-[15px] 2xl:text-[18px]">{t('t79')} {studentName}</p>
                            <p className="pt-[20px] text-[15px] 2xl:text-[18px]">{t('t81')}</p>
                        </div>
                    </DialogContent>

                </DialogContent>
                <DialogActions
                    style={{
                        backgroundColor: '#FFF6DA',
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                    }}
                >
                    <Button
                        disabled={loadingPage}
                        onClick={() => {
                            setOpen(false);
                        }}
                        style={{
                            margin: '0px 0px 10px 0px',
                            backgroundColor: '#F2AC0E',
                            color: 'white',
                            padding: '10px 20px', // px-4 py-2
                            borderRadius: '0.375rem', // rounded-md
                            fontWeight: 'bold',
                        }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open2}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className="items-center justify-center flex">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                    </DialogContent>

                </DialogContent>
            </Dialog>
        </div>
    )
}

export default StudentsDashboardPageDesktop;
